import { message } from 'antd';
import moment from 'moment';

import { getCookie } from './cookie';

export const protocol = document.location.protocol;

export const commonHost = window.location.hostname.includes('qxwz') && window.location.hostname.replace(/^[\w-]+|\.my/g, '') || '.qxwz.com';

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mini/i.test(navigator.userAgent);

export const isApp = /qxwz/i.test(navigator.userAgent);

export function shouldLogin(code: number | string) {
    return code === 'UNAUTHENTICATED' || [201, 302, 2100006, 2300104].includes(+code);
}

export function gotoLogin() {
    if (!window.location.href.includes('qxwz')) {
        message.error('请使用官网域名访问，类似：console.my.qxwz.com, console.my.qxwz-daily.web.wz-inc.com, local.qxwz-daily.web.wz-inc.com', 0);
    } else {
        window.location.href = `//passport${commonHost}/login?return_url=${encodeURIComponent(window.location.href)}`;
    }
}

/**
 * 转换成线上环境的网址，配置成线下时，强制改为线上生产环境 pre.qxwz, stage.qxwz, qxwz-test4.web.wz-inc
 * @param {string} link
 */
export function proLink(link?: string) {
    return (
        link &&
        link
            .replace(/pre\.qxwz|stage\.qxwz|qxwz-\w+\.web\.wz-inc/gi, 'qxwz')
            .replace(/^https?:/gi, '')
            .replace('.pre', '')
    );
}

/**
 * 转换成当前环境的网址
 * @param {string} link
 * @param {string} _host 当前 host，用于 mock test
 */
export function normalizeLink(link?: string) {
    link = proLink(link) || '';
    if (!link || link === '#') {
        // eslint-disable-next-line no-script-url
        return 'javascript:void(0)';
    }
    // bbs.qxwz.com, static0.qxwz.com, static.qxwz.com 只有生产环境，其他的替换为测试是链接
    if (/^\/\/(bbs|static\d+)\./i.test(link) || commonHost === '.qxwz.com') {
        return link;
    }
    return link.replace(/\.qxwz\.com/gi, commonHost).replace(/\.my\.pre\.|\.pre\.my\./, '-my.pre.');
}

export function validCms(content?: { date?: string[] }[]) {
    if (!content || !content.length || !(content instanceof Array)) return;

    // ps: 如果当前时间是一个invalid时间, moment.isBetween 会直接返回false.
    const mockTime = getCookie('6361b7fb348d212a61773fa58a3130e0');
    const now = mockTime ? moment(mockTime) : moment();

    return content.filter(item => item?.date?.length === 2 && now.isBetween(item.date[0], item.date[1]));
}

/**
 * 剩余时长
 */
export function getRatingValue(rating: string) {
    if (!rating) {
        return '';
    }
    const [year, month, day] = rating.split('-');
    if(year === '0' && month  === '0' && day === '0'){
        return '--';
    }else{
        return +year ? `${+year}年` : +month ? `${+month}月` : `${+day}天`;
    }
    
}

const ratingTypes = { 1: '月', 2: '天', 3: 'MB', 4: '次', 5: '分' }
/**
 * 新购时的时长
  `rating_type` int(2) DEFAULT NULL COMMENT '计费类型 （1 包年包月 2 按天 3 按流量计费（MB） 4 按调用次数 5 按分钟数）',
  `total_quantity` int(10) DEFAULT NULL COMMENT '总量，如总流量/总时长/总次数/天数/月份数',
 */
export function getQuality(totalQuantity: number, ratingType: number) {
    return totalQuantity ? `${totalQuantity}${ratingTypes[ratingType]}` : '';
}

/**
 * 设备状态
 */
export function getStatusLabel(status: number) {
    return { 0: '未激活', 1: '未激活', 2: '已过期', 3: '暂停', 4: '关闭', 9: '服务中', 99: '即将过期' }[status] || status;
}

/**
 * 接入方式
 */
export function getAccessLimitLabel(value: string) {
    return {
        ALL: 'NTRIP或SDK',
        SDK_ONLY: 'SDK接入',
        NTRIP_ONLY: 'NTRIP接入',
        0: 'NTRIP或SDK',
        1: 'SDK接入',
        2: 'NTRIP接入',
    }[value] || value || '-';
}

export function gotoAuth() {
    if(isApp){
        window.location.href = 'qxapp://auth/auth?authtype=0';
    } else {
        window.location.href = `//passport${commonHost}/auth?redirect_url=${encodeURIComponent(
            window.location.href,
        )}`
    }
}
